<template lang="pug">
  form(v-if="formData" @submit="submit($event, 'general')" enctype="multipart/form-data")

    v-text-field(
      v-if="!isCreateView"
      required
      color="primary"
      label="Número de proyecto"
      v-model="formData.number"
      :disabled="true"
      :error-messages="getMessageErrors('formData.number')"
      @input="$v.formData.number.$touch()"
      @blur="$v.formData.number.$touch()"
    )

    v-text-field(
      v-if="isCreateView"
      required
      clearable
      color="primary"
      label="Identificador o código de proyecto"
      v-model="formData.code"
      :disabled="sending"
      :error-messages="messageErrorsByCode"
      hint="Longitud entre 1 y 100 caracteres. Solo se permiten letras en minúscula (a-z), números, guiones y barras bajas. Una vez guardado, el identificador no se puede cambiar."
      persistent-hint
      @input="$v.formData.code.$touch()"
      @blur="$v.formData.code.$touch()"
    )

    v-text-field(
      required
      clearable
      color="primary"
      label="Nombre del proyecto"
      v-model="formData.name"
      :disabled="sending"
      :error-messages="getMessageErrors('formData.name')"
      @input="$v.formData.name.$touch()"
      @blur="$v.formData.name.$touch()"
    )

    v-text-field(
      required
      clearable
      color="primary"
      label="Slogan"
      v-model="formData.slogan"
      :disabled="sending"
      :error-messages="getMessageErrors('formData.slogan')"
      @input="$v.formData.slogan.$touch()"
      @blur="$v.formData.slogan.$touch()"
    )

    .text-box-editor-container(:class="getValidationClass('formData.descripcion')")
      label Descripción
      TextBoxEditor(v-model="formData.descripcion" :class="getValidationClass('formData.descripcion')")
      span.error--text(v-if="!$v.formData.descripcion.required") Requerido

    v-text-field(
      clearable
      color="primary"
      label="Número de Whatsapp"
      v-model="formData.whatsapp"
      :disabled="sending"
      :error-messages="getMessageErrors('formData.whatsapp')"
      @input="$v.formData.whatsapp.$touch()"
      @blur="$v.formData.whatsapp.$touch()"
    )

    custom-input-file(
      clearable
      label="KML"
      v-model="formData.kml"
      :error-messages="getMessageErrors('formData.kml')"
      :disabled="sending"
      accept=".KML"
      @change-files="loadKML"
      @input="$v.formData.kml.$touch()"
      @blur="$v.formData.kml.$touch()"
    )

    .color-picker-container
      label Color
      color-picker(v-model="formData.color")
      span.error--text(v-if="!$v.formData.color.required") Requerido

    .images-container(:class="getValidationClass('formData.images')")
      .error--text(v-if="!!$v.formData.images.$params.required && !$v.formData.images.required") Requerido
      div(v-if="formData.images")
        template(v-for="(v, index) in $v.formData.images.$each.$iter")
          div
            ButtonWithAlertDialog(
              title="Eliminar imagen"
              message="¿ Está seguro que desea eliminar esta imagen ?"
              @on-confirm="removeImage(index)"
            ) Eliminar imagen
          img(
            ref="projectImages"
            :id="`project-image-${index}`"
            :src="getImageSrcIfExist(v.$model, index)"
            @load="onLoadImage"
          )
          custom-input-file(
            clearable
            label="Cargar imagen"
            v-model="v.$model"
            :error-messages="getMessageErrors(`formData.images.$each.${index}`)"
            :disabled="sending"
            accept="image/*"
            @change-files="showImages($event, index)"
            @input="v.$touch()"
            @blur="v.$touch()"
          )

      v-btn(@click="addImage()") Agregar imagen
    v-btn(color="primary" v-show="!isCreateView" type="submit" ref="saveButton") Guardar

</template>

<script>
import { mapGetters } from 'vuex'
import { hasValue } from '@/utils/object.js'
import { required } from 'vuelidate/lib/validators'
import projectFormMixin from '@/mixins/project-form.js'

export default {
  mixins: [ projectFormMixin ],
  data: () => ({
    files: null
  }),
  created () {
    this.initFilesValues()
  },
  mounted () {
    setTimeout(() => {
      if (this.isCreateView) this.setNumber(this.getNewNumber)
    })
  },
  validations () {
    let validations = {
      formData: {
        name: {
          required
        },
        descripcion: {
          required
        },
        slogan: {
          required
        },
        whatsapp: { },
        kml: { },
        color: {
          required
        },
        images: {
          $each: { }
        },
        ...this.customValidations
      }
    }
    if (this.isCreateView) {
      validations.formData = {
        ...validations.formData,
        kml: {
          required
        },
        images: {
          required,
          $each: {
            required
          }
        }
      }
    }
    return validations
  },
  methods: {
    hasValue: hasValue,
    getKeys: Object.keys,
    getImageSrcInFile (file) {
      return new Promise((resolve, reject) => {
        if (!file) return reject(new Error('File not found'))
        if (!FileReader) return reject(new Error('FileReader not supported'))
        const fr = new FileReader()
        fr.onload = () => resolve(fr.result)
        fr.readAsDataURL(file)
        if (fr.result) resolve(fr.result)
      })
    },
    showImages (event, idx) {
      if (event && event.length) {
        const self = this
        const file = event[0]
        this.getImageSrcInFile(file).then(imgSrc => {
          self.$refs.projectImages[idx].src = imgSrc
          self.files.images[idx] = file
          self.$set(self.formData.images, idx, file.name)
          self.$emit('input', self.formData)
          self.$emit('on-change-files', self.files)
        }).catch(err => console.warn(err))
      }
    },
    getImageSrcIfExist (src, idx) {
      const file = this.files.images[idx]
      if (file) {
        this.getImageSrcInFile(file).then(imgSrc => { if (imgSrc) this.$refs.projectImages[idx].src = imgSrc })
        return ''
      }
      if (src && typeof src === 'string') return this.getImageSRC('images', src)
    },
    onLoadImage (event) {
      this.$emit('on-change-tab-height', {})
    },
    addImage () {
      this.formData.images.push('')
    },
    removeImage (idx) {
      this.$set(this.files, 'images', this.files.images.filter((v, i) => i !== +idx))
      this.$set(this.formData, 'images', this.formData.images.filter((v, i) => i !== +idx))
    },
    initFilesValues () {
      if (!this.files) this.files = {}
      if (!this.files.images) this.files.images = []
      if (!this.files.kml) this.files.kml = []
    },
    loadKML (event) {
      if (event && event.length) {
        const file = event[0]
        this.files.kml[0] = file
        this.$emit('input', this.formData)
        this.$emit('on-change-files', this.files)
      }
    },
    setNumber (promise) {
      promise(this.$http).then(number => {
        if (!this.formData) return
        this.formData.number = number
      })
    }
  },
  computed: {
    ...mapGetters(['getNewNumber']),
    messageErrorsByCode () {
      if (!this.$v.formData.code.$dirty) return []
      const errors = this.getMessageErrors('formData.code')
      !this.$v.formData.code.codeValidator && errors.push('El valor introducido es incorrecto, solo se permiten números, letras en minúsculas o guiones')
      return errors
    }
  },
  watch: {
    getNewNumber (promise) {
      if (this.isCreateView) this.setNumber(promise)
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/edit-project-form-style'

.images-container
  border-radius: 3px
  border: 1px solid $gray
  padding: $f20px
  button
    margin-top: 0
    margin-left: 0

.md-invalid
  &.images-container
    border-color: var(--md-theme-default-fieldvariant, #ff1744)
  &.text-box-editor-container label
    color: var(--md-theme-default-fieldvariant, #ff1744)

</style>
